import React from "react";
import theme from "../../../styles/theme";

const ContainerBase = ({
  sections = [],
  gap = theme.spacing.md,
  sectionGap = theme.spacing.sm,
  contentPadding = theme.spacing.sm,
  titleStyle = {},
  iconSize = 18,
  style = {},
}) => {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        minWidth: 0,
        minHeight: 0,
        display: "flex",
        flexDirection: "column",
        gap,
        overflow: "hidden",
        boxSizing: "border-box",
        ...style,
      }}
    >
      {sections.map((section, index) => (
        <div
          key={index}
          style={{
            display: "flex",
            flexDirection: "column",
            gap: sectionGap,
            minWidth: 0,
            minHeight: 0,
            
            flex: "0 0 auto",
            overflow: "auto",
            boxSizing: "border-box",
          }}
        >
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: theme.spacing.xs,
              minWidth: 0,
              flex: "0 0 auto",
              boxSizing: "border-box",
            }}
          >
            {section.icon && (
              <img
                src={section.icon}
                alt=""
                style={{
                  width: iconSize,
                  height: iconSize,
                  flexShrink: 0,
                }}
              />
            )}

            <span
              style={{
                fontFamily: theme.fonts.primary,
                fontSize: theme.fontSizes.md,
                fontWeight: theme.fontWeights.medium,
                color: theme.colors.text.primary,
                minWidth: 0,
                ...titleStyle,
              }}
            >
              {section.title}
            </span>
          </div>

          <div
            style={{
              width: "100%",
              
              minWidth: 0,
              minHeight: 0,
              padding: contentPadding,
              borderRadius: theme.borders.radius.md,
              backgroundColor: "transparent",
             overflow: "visible", // Hidden remplacé par visible pour test
              boxSizing: "border-box",
            }}
          >
            {section.content}
          </div>
        </div>
      ))}
    </div>
  );
};

export default ContainerBase;